export const taskTags = ['tasks_newTask'] as const;
